import type { Registry as Services } from '@ember/service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { IconColor } from '@mylighthouse/prism-ember/types/components/prism/icon';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import type { MarketPerformanceDataStatus } from 'lumen/models';
import {
  DATA_STATUS_ICON_COLORS,
  DATA_STATUS_TRANSLATIONS,
} from 'lumen/models/market-performance/data-status';

export interface MarketSnapshotsTableTdNameSignature {
  Args: {
    cellData?: string;
    row: { dataStatus?: MarketPerformanceDataStatus | null };
  };
}

export default class MarketSnapshotsTableTdName extends Component<MarketSnapshotsTableTdNameSignature> {
  @service declare intl: Services['intl'];

  get status(): { color: IconColor; label: string } | null {
    const status = this.args.row.dataStatus?.status;

    if (!status) {
      return null;
    }

    return {
      color: DATA_STATUS_ICON_COLORS[status],
      label: this.intl.t(DATA_STATUS_TRANSLATIONS[status]),
    };
  }

  <template>
    <div class="flex items-center gap-100">
      {{! min-w-0 lets the name truncate so the bullet after it stays visible }}
      <div class="min-w-0 truncate" title={{@cellData}}>{{@cellData}}</div>

      {{#if this.status}}
        <div class="flex shrink-0 items-center">
          <GeneralIconWithTooltip
            @color={{this.status.color}}
            @iconName="bullet"
            @size="small"
            @tooltipContent={{this.status.label}}
          />
          {{! The tooltip only shows on hover and the colour alone isn't enough }}
          <span class="sr-only">{{this.status.label}}</span>
        </div>
      {{/if}}
    </div>
  </template>
}
